module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eRRr7"))).then(() => parcelRequire('1iHdE'));